import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";

addToChainAfter(chain, PopulateApiParameter, props => {
    if (props.apiParameter.expand) {
        props.apiParameter.expand.push("warehouses");
    } else {
        props.apiParameter.expand = ["warehouses"];
    }
});
